import { Component, Input, SimpleChanges } from "@angular/core";
import { KeycloakService } from "keycloak-angular";
import { Router } from "@angular/router";
import { KeycloakStateService } from "../core/service/utility.service";
import { environment } from '@env';
@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent {
  constructor(public router: Router, public keycloakService: KeycloakService, public keycloakStateService: KeycloakStateService) {}
  @Input() isLoggedIn: boolean = false;
  isDropdownVisible = false;

  async ngOnInit() {
    this.isLoggedIn = await this.keycloakService.isLoggedIn();
  }

  // async  ngOnChanges(changes: SimpleChanges) {
  //   if(changes['isLoggedIn'] ) {

  //   this.isLoggedIn = await this.keycloakService.isLoggedIn();
  // }
  // }

  toggleDropdown() {
    this.isDropdownVisible = !this.isDropdownVisible;
  }

  async toggleLogin() {
    await this.keycloakStateService.loginOrLogout(this.isLoggedIn);
     this.isLoggedIn = await this.keycloakService.isLoggedIn();
  }

 

  navigateToHome() {
    this.router.navigate(['/']).then(() => {
      setTimeout(() => {
        const contactSection = document.getElementById('contact');
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 500); // Delay to ensure page loads before scrolling
    });
  }
}
